module.exports = __webpack_public_path__ + "img/picture1.299df911.png";